import React from 'react';
import { RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, ResponsiveContainer } from 'recharts';
import { ExtractedDocumentData, ScoringDimensions } from '../../types';
import RecommendedByAI from '../ui/RecommendedByAI';
import { TalentPageCard, TalentPageCardContent, TalentPageCardHeader, TalentPageCardTitle } from '../ui/TalentPageCard';

interface RadarChartCardProps {
  extractedData: ExtractedDocumentData;
  scoringResults?: ScoringDimensions;
  className?: string;
}

const RadarChartCard: React.FC<RadarChartCardProps> = ({
  extractedData,
  scoringResults,
  className = ''
}) => {

  // Map dimension keys to display names
  const dimensionDisplayNames: { [key: string]: string } = {
    'ambiguity': 'Ambiguity',
    'scope_influence': 'Scope Influence',
    'execution': 'Execution',
    'communication': 'Communication',
    'impact': 'Impact',
    'process_improvement': 'Process Improvement',
  };

  // Build chart data from actual scoring results
  const chartData = scoringResults ? Object.entries(scoringResults).map(([key, data]) => ({
    dimension: dimensionDisplayNames[key] || key,
    score: data.score || 0,
    fullMark: 5,
  })) : [
    // Fallback to default data if no scoring results
    { dimension: 'Ambiguity', score: 4.2, fullMark: 5 },
    { dimension: 'Scope Influence', score: 3.8, fullMark: 5 },
    { dimension: 'Execution', score: 4.5, fullMark: 5 },
    { dimension: 'Communication', score: 4.1, fullMark: 5 },
    { dimension: 'Impact', score: 3.9, fullMark: 5 },
    { dimension: 'Process Improvement', score: 4.3, fullMark: 5 },
  ];

  return (
    <TalentPageCard variant="static" className={className}>
      <TalentPageCardHeader>
         <div className="flex items-center justify-between mb-2">
           <TalentPageCardTitle>Skills Assessment</TalentPageCardTitle>
           <RecommendedByAI size="sm" />
         </div>
         <p className="text-[var(--font-size-sm)] font-[var(--font-family-primary)] text-[var(--text-tertiary)]">Performance across key dimensions</p>
       </TalentPageCardHeader>
       <TalentPageCardContent>
      
      <div className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          <RadarChart
            cx="50%"
            cy="50%"
            outerRadius="80%"
            width={300}
            height={300}
            data={chartData}
          >
            <PolarGrid className="stroke-gray-50" strokeWidth={0.5} fill="#fafafa" fillOpacity={0.1} />
            <PolarAngleAxis 
              dataKey="dimension" 
              className="text-[var(--font-size-xs)] fill-gray-700"
              tick={{ fontSize: 11, fill: '#374151', fontWeight: 500 }}
            />
            <PolarRadiusAxis 
              angle={90} 
              domain={[0, 5]} 
              className="text-[var(--font-size-xs)] fill-gray-500"
              tick={{ fontSize: 10, fill: '#6B7280' }}
            />
            <Radar
              name="Score"
              dataKey="score"
              stroke="#6366F1"
              fill="#f8fafc"
              fillOpacity={0.3}
              strokeWidth={2.5}
              dot={{ fill: '#6366F1', strokeWidth: 2, r: 5, fillOpacity: 1 }}
            />
          </RadarChart>
        </ResponsiveContainer>
      </div>
      </TalentPageCardContent>
    </TalentPageCard>
  );
};

export default RadarChartCard;